<!--
 * @Author: cts 308360781@qq.com
 * @Date: 2025-06-23 22:58:48
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-06-24 19:02:17
 * @FilePath: \web2\src\views\yunke\project\add_query.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEv
-->
<template>
  <el-button type="primary" size="small" icon="plus" round @click="onOpen"
    ><slot> 查询项目 </slot>
  </el-button>
  <el-dialog
    title="查询开发商直连项目"
    v-model="dialogVisible"
    width="800"
    :destroy-on-close="true"
    :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="标题名称" prop="name">
        <el-input
          v-model="form.name"
          style="width: 380px"
          placeholder="开发商名或者驻场"
        ></el-input>
      </el-form-item>
      <el-form-item label="直连系统类型" prop="exter_type">
        <el-radio-group v-model="form.exter_type">
          <el-radio :label="2">云客</el-radio>
          <el-radio :label="3">盟拓</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile_tel">
        <el-input
          v-model="form.mobile_tel"
          style="width: 180px"
          placeholder="开发商报备手机号码"
        ></el-input>
      </el-form-item>

      <el-form-item label="驻场类型" prop="exter_resident_type">
        <el-radio-group v-model="form.exter_resident_type">
          <el-radio :label="1">驻场</el-radio>
          <el-radio :label="2">经纪人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="开发商报备链接"
        v-if="form.exter_type == 2 && form.exter_resident_type == 2"
      >
        <el-input v-model="form.yk_recommend_link" placeholder=""></el-input>
        <div>
          <el-text type="info"
            >直连的系统类型选择【云客】时且开发商直连的驻场类型为【经纪人】时必填</el-text
          >
        </div>
      </el-form-item>
      <template v-if="form.exter_type == 3">
        <el-form-item label="盟拓开发商租户标识">
          <el-input
            v-model="form.exter_org"
            placeholder=""
            style="width: 200px"
          ></el-input>
          <div class="help-block">直连的系统类型选择【盟拓】时必填</div>
        </el-form-item>
        <el-form-item label="盟拓开发商账号验证信息">
          <el-input
            v-model="form.resident_password"
            placeholder=""
            style="width: 200px"
          ></el-input>
          <div class="help-block">直连的系统类型选择【盟拓】时必填</div>
        </el-form-item>
      </template>

      <el-form-item label="开发商直连项目列表">
        <el-table :data="dataList" border>
          <el-table-column label="" v-if="isChecked" width="80">
            <template #default="{ row }">
              <el-checkbox
                v-model="row.checked"
                @change="onCheckChange(row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            label="yk项目名称"
            prop="proj_name"
          ></el-table-column>
          <el-table-column label="yk租户号" prop="org_code"></el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <!-- <template #footer>
      <el-button type="primary" @click="onSubmit" :loading="saving"
        >立即查询</el-button
      >
    </template> -->
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      saving: false,
      isSubmit: true,
      form: {},
      rules: {
        exter_type: [
          { required: true, message: "请选择直连系统类型", trigger: "change" },
        ],
        mobile_tel: [
          {
            required: true,
            message: "请输入开发商报备手机号码",
            trigger: "blur",
          },
        ],
        exter_resident_type: [
          { required: true, message: "请选择驻场类型", trigger: "change" },
        ],
      },
      dataList: [],
    };
  },
  emits: ["success", "change"],
  props: {
    /**
     * 是否允许选择
     */
    isChecked: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  methods: {
    /**
     *
     */
    onOpen() {
      this.dialogVisible = true;
      this.form = {
        exter_type: 2,
        exter_resident_type: 2,
      };
    },

    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;

          this.$http
            .post("admin/v1/yunkeproject/query", this.form)
            .then((res) => {
              if (res.code === 0 && res.data && res.data.length) {
                this.isSubmit = false;
                this.dataList = res.data;
                this.dataList.forEach((item) => {
                  item.checked = false;
                });
                this.$emit("success");
              }
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },

    /**
     *
     * @param row
     */
    onCheckChange(row) {
      this.dataList.forEach((item) => {
        if (item.proj_id != row.proj_id) {
          item.checked = false;
        }
      });
      this.$emit("change", row.checked ? { ...row } : null);
    },
  },
};
</script>

<style scoped></style>
